module.exports = __webpack_public_path__ + "static/media/aka_logo-13.af2819a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/aka_logo-13.png
// module id = 526
// module chunks = 0